import { isValidEmail } from '@/utils/isValidEmail/isValidEmail';
import { isValidAustralianPhoneNumber } from '@montu-web/utilities/isValidAustralianPhoneNumber';
import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';

export const schema = GetPatientDetailsSchema.shape.contactDetails
  .unwrap()
  .shape.attributes.pick({
    phone: true,
    email: true
  })
  .partial()
  .refine(
    (data) => {
      return (data.phone || '').length === 0 || isValidAustralianPhoneNumber(data.phone || '');
    },
    {
      message: 'Invalid phone number',
      path: ['phone']
    }
  )
  .refine(
    (data) => {
      return (data.email || '').length === 0 || isValidEmail(data.email || '');
    },
    {
      message: 'Invalid email',
      path: ['email']
    }
  );
